import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

// `/catalog-management/products/{id}/detail` is the URL every order, stock
// and production page links to. There is one product page now (read-only or
// editable by policy), so the legacy path redirects to it, keeping any hash.
const ProductDetailRedirect = () => {
    const { id } = useParams();
    const { hash } = useLocation();
    return <Navigate to={`/catalog-management/products/${id}${hash || ''}`} replace />;
};

export default ProductDetailRedirect;
